/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// bootstrap-vue
// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

Vue.component('news', require('./components/news').default);
Vue.component('store', require('./components/store').default);
Vue.component('store-detail', require('./components/store-detail').default);
Vue.component('store-detail-preview-upd', require('./components/store-detail-preview-upd').default);

Vue.component('purchase', require('./components/purchase').default);
Vue.component('purchased-item', require('./components/purchased-item').default);
Vue.component('purchased-item-detail', require('./components/purchased-item-detail').default);
Vue.component('purchase-history', require('./components/purchase-history').default);
Vue.component('add-playlist', require('./components/add-playlist').default);
Vue.component('cart-confirm', require('./components/cart-confirm').default);
Vue.component('purchase-confirm', require('./components/purchase-confirm').default);
Vue.component('playlist-detail', require('./components/playlist-detail').default);
Vue.component('store-hls-player', require('./components/store-hls-player').default);
Vue.component('digicon-player', require('./components/digicon-player').default);
Vue.component('purchase-end', require('./components/purchase-end').default);
Vue.component('input-benefit-info', require('./components/input-benefit-info').default);
Vue.component('show-benefit-content', require('./components/show-benefit-content').default);
Vue.component('live', require('./components/live').default);
Vue.component('live-list', require('./components/live-list').default);
Vue.component('live-list-ticket', require('./components/live-list-ticket').default);
Vue.component('twitter-embed', require('./components/twitter-embed').default);
Vue.component('subscription-confirm', require('./components/subscription-confirm').default);
Vue.component('subscription-purchase', require('./components/subscription-purchase').default);
Vue.component('subscription-purchase-history', require('./components/subscription-purchase-history').default);
Vue.component('subscription-purchase-end', require('./components/subscription-purchase-end').default);
Vue.component('subscription-purchase-auto', require('./components/subscription-purchase-auto').default);
Vue.component('credit-regist', require('./components/credit-regist').default);
Vue.component('photo-slider', require('./components/photo-slider').default);
Vue.component('photo-slider-preview-new', require('./components/photo-slider-preview-new').default);
Vue.component('photo-slider-preview-upd', require('./components/photo-slider-preview-upd').default);
Vue.component('blog', require('./components/blog').default);
Vue.component('discography', require('./components/discography').default);
Vue.component('favorite-list', require('./components/favorite-list').default);
Vue.component('playlog-list', require('./components/playlog-list').default);
Vue.component('tmariko-video-player', require('./components/tmariko-video-player').default);
Vue.component('positivesalon-video-player', require('./components/positivesalon-video-player').default);
Vue.component('positivesalon-audio-player', require('./components/positivesalon-audio-player').default);
Vue.component('thread-list', require('./components/thread-list').default);
Vue.component('thread-detail', require('./components/thread-detail').default);
Vue.component('thread-create', require('./components/thread-create').default);
Vue.component('comment-history', require('./components/comment-history').default);
Vue.component('topic-list', require('./components/topic-list').default);
Vue.component('chage-audio-player', require('./components/chage-audio-player').default);
Vue.component('klp48-audio-player', require('./components/klp48-audio-player').default);
Vue.component('azenc-video-player', require('./components/azenc-video-player').default);
Vue.component('positivesalon-video-new-player', require('./components/positivesalon-video-new-player').default);
Vue.component('positivesalon-audio-new-player', require('./components/positivesalon-audio-new-player').default);

Vue.component('post-form', require('./components/post-form').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
